import { render, staticRenderFns } from "./PreLoginOtpInput.vue?vue&type=template&id=56efdb52"
import script from "./PreLoginOtpInput.vue?vue&type=script&lang=js"
export * from "./PreLoginOtpInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports